import type { PageContext } from 'vike/types';
import { useCheckoutStore } from '../stores/checkout';

export const initEventId = (pageContext: PageContext) => {
  const checkoutStore = useCheckoutStore();

  if (pageContext.routeParams.event_id) {
    if (pageContext.routeParams.event_id) {
      checkoutStore._selectedEventId = pageContext.routeParams.event_id;
    }
  }
};
